export enum UICardType {
  Group = 'Group',
  PreviewGroup = 'PreviewGroup',
  Category = 'Category',
  Activity = 'Activity',
  Proficiency = 'Proficiency',
  Event = 'Event',
  EventsCategory = 'EventsCategory',
  EventsSchedule = 'EventsSchedule',
}
